import { createStyles, makeStyles } from "@mui/styles";
//CSS Imports
import "@root/screens/LoginV2/styles.scss";

export const AuthBottom = ({
    linkName,
    title,
}: ILink) => {
    const useStyles = makeStyles(() =>
        createStyles({
            textWrap: {
                color: "#ffffff",
                fontSize: "16px",
                fontFamily: "Wix Madefor Text",
                fontWeight: 400,
                height: "20px",
            },
            linkName: {
                fontWeight: 500,
                textDecoration: "underline",
            }
        })
    );

    const classes = useStyles();

    return (
        <>
            <div className="row text-center">
                <div className="w-full flex items-center justify-center authbottom">
                    <span className={classes.textWrap}>
                        {title}
                        <a href="mailto:support@cashd.com.au" className={classes.linkName}>
                            {linkName}
                        </a>
                    </span>
                </div>
            </div>
        </>
    );
};

interface ILink {
    linkName?: string;
    title?: string;
}